<template>
  <div id="safety">
    <mt-header fixed title>
      <mt-button icon="back" slot="left" @click="$router.back()"></mt-button>
    </mt-header>
    <div class="content">
      <div class="swiper">
        <p class="wx_fontSize4" style="font-weight: bold;">{{$t('请确认 HMC Wallet Pro 助记词')}}</p>
        <p class="wx_fontSize2">{{$t('为了确保您已将 HMC Wallet Pro 助记词正确的抄写，请选择对应序号的单词。')}}</p>
      </div>
      <ul class="select clearfix">
        <div class="order wx_fontSize5">#{{order}}</div>
        <li
          v-for="(item,index) in list"
          class="wx_fontSize4"
          @click="toggle(index,item)"
          :class="{ 'is_active':index==active}"
          :key="index"
        >{{item}}</li>
      </ul>
      <div class="footer wx_fontSize3" @click="backupTip()">{{sure ? $t("完成") : $t("下一步")}}</div>
    </div>
  </div>
</template>

<script>
import { validateEmpty } from "@/utils/validate";
import { createUniqueString } from "@/utils/index";
import { generateAddress } from "@/utils/hdwallet";
import { httpList, httpChainList, httpCreate, httpInit } from "@/api/hdwallet";
import { Toast } from "mint-ui";
export default {
  data() {
    return {
      btcAddress: window.LS.get('btcAddress'),
      ethAddress: window.LS.get('ethAddress'),
      hmcAddress: window.LS.get('hmcAddress'),
      order: 0,
      list: [],
      active: 0,
      type: 0,
      sure: false,
      menmonic: window.LS.get("mnemonic").split(" "),
      temp: ""
    };
  },
  activated() {
    this.type = 0;
    this.nextStep();
  },
  methods: {
    toggle(index, val) {
      this.active = index;
      this.temp = val;
    },
    nextStep: function() {
      this.order = parseInt(Math.random() * 12 + 1);
      this.list = window.LS.get("mnemonic")
        .split(" ")
        .sort(function() {
          return Math.random() - 0.5;
        });
      this.active = 0;
      this.temp = this.list[0];
    },
    createHdWallet: function() {
      return httpCreate({ deviceType: 'web', primaryAddress: this.btcAddress })
        .then(res => {
          this.$store.dispatch("setHdToken", res.result);
          this.initHdWallet(res.result);
        })
        .catch(() => {});
    },
    initHdWallet: function() {
      httpChainList().then(({result})=>{
        let promise1, promise2, promise3
        result.forEach(chain=>{
          if (chain.symbol === 'BTC')  promise1 = httpInit({address: this.btcAddress, chainId: chain.id})
          else if (chain.symbol === 'ETH') promise2 = httpInit({address: this.ethAddress, chainId: chain.id})
          else if (chain.symbol === 'HMC') promise3 = httpInit({address: this.hmcAddress, chainId: chain.id})
        })
        Promise.all([promise1, promise2, promise3]).then(()=>{
          this.$router.push("/index").catch(()=>{});
        })
      })
    },
    backupTip() {
      console.log(this.temp);
      console.log(this.menmonic[this.order]);
      if (this.temp != this.menmonic[this.order - 1]) {
        Toast(this.$t("验证错误"));
        return;
      }
      this.nextStep();
      this.type++;
      if (this.type >= 2) {
        this.sure = true;
      }
      if (this.sure && this.type >= 2) {
        this.createHdWallet();
      }
    }
  }
};
</script>

<style scoped>
#safety {
  width: 100%;
  min-height: 100%;
  background-image: url('../../assets/img/index/bg_bendi_home.png');
}
.mint-header {
  background: transparent;
}
.backG {
  width: 100%;
  height: 100%;
}
.mark {
  width: 86%;
  margin-left: 7%;
  margin-top: 50px;
  height: 36%;
}
.content {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  box-sizing: border-box;
}
.swiper {
  box-sizing: border-box;
  border-radius: 10px;
  color: #fff;
  padding: 10px;
  box-sizing: border-box;
  padding-top: 30px;
}
.swiper p {
  margin: 15px 5px;
}
.select {
  padding: 15px;
}
.order {
  color: #fff;
}
.select .is_active {
  background: #fff;
  color: #1296db;
}
.select li {
  float: left;
  text-align: center;
  color: #fff;
  border: 1px solid #fff;
  position: relative;
  padding: 5px 12px;
  border-radius: 5px;
  margin-left: 10px;
  margin-right: 5px;
  margin-top: 15px;
}

.footer {
  width: calc(100% - 30px);
  height: 50px;
  background: #fff;
  line-height: 50px;
  text-align: center;
  color: #1296db;
  border-radius: 4px;
  margin-left: 15px;
  position: relative;
  margin-top: 20px;
  margin-bottom: 20px;
}
.mint-badge.is-primary {
  background: transparent;
  position: absolute;
  top: -18px;
  left: 5px;
}
</style>
